import { Award_Points_Rounding_Strategy } from '@occc/graphql';

export const selectData = [
  {
    value: Award_Points_Rounding_Strategy.Down,
    label: 'Down',
  },
  {
    value: Award_Points_Rounding_Strategy.HalfUp,
    label: 'Half Up',
  },
];
